import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { validatePackage } from '@progress/kendo-licensing';
import { packageMetadata } from './package-metadata';
/**
 * Represents the KendoReact Hint component.
 * Render the hint text that will be shown underneath the form editor.
 */

export var Hint = function Hint(props) {
  validatePackage(packageMetadata);
  var hintClassName = classNames({
    'k-form-hint': true,
    'k-text-start': props.direction === 'start',
    'k-text-end': props.direction === 'end'
  }, props.className);
  return React.createElement("div", {
    id: props.id,
    style: props.style,
    className: hintClassName
  }, props.children);
};
Hint.propTypes = {
  id: PropTypes.string,
  direction: PropTypes.oneOf(['start', 'end']),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  style: PropTypes.object,
  className: PropTypes.string
};
Hint.defaultProps = {
  direction: 'start'
};
Hint.displayName = 'KendoReactHint';